const PropTypes = require('prop-types');

module.exports = {
  openModalImage: PropTypes.bool.isRequired,
  setOpenModalImage: PropTypes.func.isRequired,
  modalImageSrc: PropTypes.string.isRequired
};
